import { SceneManager } from "./SceneManager"
import { initMouseListener } from "./utils/mouse"
import { initializeStartButton } from "./utils/start-button"


initMouseListener()
initializeStartButton()

const canvas = document.querySelector('#glcanvas') as HTMLCanvasElement
new SceneManager(canvas)